if (!customElements.get("age-verification")) {
  class AgeVerification extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector(".age-verification-overlay");
      this.btnApprove = this.querySelector('[data-action="approve"]');
      this.btnDecline = this.querySelector('[data-action="decline"]');

      this.isDesignMode = this.dataset.designMode === "true";
      this.redirectUrl = this.dataset.redirectUrl;
    }

    connectedCallback() {
      this.checkVerificationStatus();
      this.bindEvents();
    }

    checkVerificationStatus() {
      if (this.isDesignMode) {
        this.showModal();
        return;
      }

      const isVerified = localStorage.getItem("isAgeVerified");
      if (!isVerified) {
        this.showModal();
      }
    }

    showModal() {
      if (this.overlay) {
        this.overlay.style.display = "flex";
        document.body.style.overflow = "hidden";
      }
    }

    hideModal() {
      if (this.overlay) {
        this.overlay.style.display = "none";
        document.body.style.overflow = "";
      }
    }

    handleApprove() {
      if (!this.isDesignMode) {
        localStorage.setItem("isAgeVerified", "true");
        this.hideModal();
      } else {

      }
    }

    handleDecline() {
      window.location.href = this.redirectUrl;
    }

    bindEvents() {
      if (this.btnApprove) {
        this.btnApprove.addEventListener(
          "click",
          this.handleApprove.bind(this),
        );
      }
      if (this.btnDecline) {
        this.btnDecline.addEventListener(
          "click",
          this.handleDecline.bind(this),
        );
      }
    }
  }

  customElements.define("age-verification", AgeVerification);
}
